
import Conversations from './APIConversationRepository';

export default {
  mounted() {       
    this.$root.$on('changeUserContainer', function(conversation){                
        this.userinfo = conversation.contact        
        this.ConversationId = conversation.id
        this.havecontrol = conversation.manual   
        this.ProjectID = conversation.project_id     
             
    }.bind(this))
  },
  methods: {
    takeControl: function(value) {      

        // chiamata API prendi controllo
        Conversations.acquireControl(this.ConversationId).then((res)=>{
          if (res.status==204){
            this.$root.$emit("manageChatStatus",true,this.ConversationId); 
            this.havecontrol=true
            this.$root.$emit("loadConversationList","mine",this.ProjectID)
            this.$root.$emit("setToggleUserDetails","mine")
          }  
        })
    },
    leaveControl: function(value) {      
  
        // chiamata API lascia controllo        
        Conversations.relesControl(this.ConversationId).then((res)=>{
          if (res.status==204){
            this.$root.$emit("manageChatStatus",false,0);      
            this.havecontrol=false   
            this.$root.$emit("loadConversationList","bot",this.ProjectID)    
            this.$root.$emit("setToggleUserDetails","bot")
          }  
        })
    }    
  } 
}    
